import * as React from 'react';
export const keybankSvg = React.forwardRef(function keybankSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EE3525',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M21.4 17.25h-6.2a2.31 2.31 0 0 1-2.02 1.13h-.29v.27c0 1.16-1.02 2.1-2.28 2.1h-.57c-1.26 0-2.28-.94-2.28-2.1v-.27h-.3c-1.25 0-2.27-.95-2.27-2.12v-.52c0-1.17 1.02-2.12 2.28-2.12h.29v-.27c0-1.16 1.02-2.1 2.28-2.1h.57c1.26 0 2.28.94 2.28 2.1v.27h.29c.87 0 1.63.46 2.02 1.13h10.37c.68 0 1.24.56 1.24 1.25 0 .7-.56 1.25-1.24 1.25H24.1c.9 0 1.63.68 1.63 1.5v1c0 .56-.48 1-1.08 1h-3.79c-.59 0-1.08-.44-1.08-1v-1c0-.82.73-1.5 1.63-1.5zM9.52 14.5v.75h-.8c-.45 0-.82.33-.82.75 0 .41.37.75.82.75h.8v.75c0 .42.36.75.81.75.45 0 .82-.34.82-.75v-.75h.8c.45 0 .82-.33.82-.75 0-.41-.37-.75-.82-.75h-.8v-.75c0-.42-.36-.75-.82-.75-.44 0-.8.34-.8.75zm12.44 4v2.26h1.62V18.5c0-.41-.36-.75-.81-.75-.45 0-.81.34-.81.75z',
      }),
    ),
  );
});
keybankSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var keybank = {
  category: 'brand',
  colorable: false,
  name: 'keybank',
  svg: keybankSvg,
};
